import { ELocale } from "@/providers/LocaleProvider/interfaces";
import API from "..";
import { TranslationsAPIResponse } from "./interfaces/translations";

export const getTranslationsForLaboratory = async (locale: ELocale) => {
  const { data } = await API.get<TranslationsAPIResponse>(
    `/laboratory/translations/${locale}`
  );
  return data;
};

export const getTranslationsForPharmacy = async (locale: ELocale) => {
  const { data } = await API.get<TranslationsAPIResponse>(
    `/pharmacy/translations/${locale}`
  );
  return data;
};
